import { AssessmentResults } from '@/types/assessment';

/**
 * Structural validation for AI-generated AssessmentResults.
 * Throws if the required top-level shape is missing.
 */
export const validateAssessmentResults = (data: unknown): AssessmentResults => {
  if (!data || typeof data !== 'object') {
    throw new Error('Invalid results: not an object');
  }
  const r = data as Record<string, unknown>;

  if (!r.youSummary || typeof r.youSummary !== 'object') {
    throw new Error('Invalid results: missing youSummary');
  }
  if (!Array.isArray(r.strengthClusters) || r.strengthClusters.length === 0) {
    throw new Error('Invalid results: missing strengthClusters');
  }
  if (!Array.isArray(r.paths) || r.paths.length === 0) {
    throw new Error('Invalid results: missing paths');
  }
  if (!Array.isArray(r.pathMatches)) {
    throw new Error('Invalid results: missing pathMatches');
  }
  if (!Array.isArray(r.radarData)) {
    throw new Error('Invalid results: missing radarData');
  }

  return data as AssessmentResults;
};
